import { CallRecordKey, QueueKey, TicketKey } from 'flow/types/EntityKeys';
import ButtonCreateTicket from './Create/ButtonCreateTicket';
import ButtonShowTicket from './Show/ButtonShowTicket';
import ButtonCreateShowTicketSkeleton from './ButtonCreateShowTicketSkeleton';
import { ButtonType } from './types';
import { SegmentContextType } from 'flow/components/call-history-v2/types';

interface Props {
    queueKey?: QueueKey;
    callRecordKey: CallRecordKey;
    ticketKey?: TicketKey;
    callerNumber?: string;
    callTimestamp?: string;
    buttonType?: ButtonType;
    segmentContext: SegmentContextType;
    // False while a fetch carrying ticket scope is still outstanding, so an
    // absent ticketKey can't yet be read as "no ticket". Defaults to true for
    // callers rendering off list data, which never fetch that scope and would
    // otherwise wait forever.
    ticketScopeIsResolved?: boolean;
}

const ButtonCreateShowTicket = ({
    queueKey,
    callRecordKey,
    ticketKey,
    callerNumber,
    callTimestamp,
    buttonType = 'iconText',
    segmentContext,
    ticketScopeIsResolved = true,
}: Props) => {
    if (ticketKey) {
        return (
            <ButtonShowTicket
                ticketKey={ticketKey}
                buttonType={buttonType}
                segmentContext={segmentContext}
            />
        );
    }

    if (!queueKey) return null;

    if (!ticketScopeIsResolved) {
        return <ButtonCreateShowTicketSkeleton buttonType={buttonType} />;
    }

    return (
        <ButtonCreateTicket
            queueKey={queueKey}
            callRecordKey={callRecordKey}
            callerNumber={callerNumber}
            callTimestamp={callTimestamp}
            buttonType={buttonType}
            segmentContext={segmentContext}
        />
    );
};

export default ButtonCreateShowTicket;
